var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 5.9751C10.6 5.9751 10.8 6.0751 10.9 6.1751L17.3 12.2751C17.5 12.4751 17.5 12.6751 17.5 12.8751C17.5 13.0751 17.4 13.2751 17.3 13.3751L10.9 19.3751C10.6 19.6751 10.1 19.6751 9.8 19.3751C9.5 19.0751 9.5 18.5751 9.8 18.2751L15.7 12.8751L9.9 7.2751C9.6 6.9751 9.6 6.4751 9.9 6.1751C10 6.0751 10.2 5.9751 10.4 5.9751Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRight);
export default ForwardRef;